import { type ReactNode } from 'react';
import { View } from 'react-native';

import { cn } from '@/components/ui/cn';

/** Full-bleed section whose inner content is centered and capped at 1160px. */
export function Section({
  children,
  className,
  innerClassName,
}: {
  children: ReactNode;
  className?: string;
  innerClassName?: string;
}) {
  return (
    <View className={cn('w-full items-center px-6', className)}>
      <View className={cn('w-full max-w-[1160px]', innerClassName)}>{children}</View>
    </View>
  );
}
